<highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag" class="pie-chart">
</highcharts-chart>
